<template>
  <div>
    <Card class="p-no-shadow-app">
      <template #title>Informação do Equipamento</template>
      <template #content>
        <div class="p-grid">
          <div class="p-col-12 p-md-4">
            <p><strong>Marca:</strong> {{ equipmentInfo?.brand }}</p>
            <p><strong>Modelo:</strong> {{ equipmentInfo?.model }}</p>
            <p><strong>Número de Série:</strong> {{ equipmentInfo?.serie }}</p>
            <p><strong>Estado:</strong> {{ equipmentInfo?.situation }}</p>
            <p>
              <strong>Data de Compra:</strong>
              {{
                equipmentInfo?.purchaseDate != "01-01-1900"
                  ? equipmentInfo?.purchaseDate
                  : ""
              }}
            </p>
          </div>
          <div class="p-col-12 p-md-4">
            <p><strong>Comentários:</strong> {{ equipmentInfo?.comments }}</p>
          </div>
        </div>
        <div class="p-mt-3" :style="{ position: 'relative' }">
          <Loading :active.sync="loading" :isFullPage="false"></Loading>
          <Divider />
          <H4
            >Histórico de Intervenções
            <Badge
              :value="patsHistory.length - 1"
              class="p-ml-2"
              size="large"
            ></Badge
          ></H4>
          <div class="p-grid">
            <Card
              class="p-col-12 p-md-3 p-mr-2"
              v-for="pat in patsHistory"
              :key="pat.id"
              v-show="pat.id !== patId"
            >
              <template #title> PAT {{ pat.id }} </template>
              <template #content>
                <p><b>Data:</b> {{ pat.date }}</p>
                <p><b>Problema:</b> {{ pat.problem }}</p>
                <p v-if="pat.resume != ''"><b>Resumo:</b> {{ pat.resume }}</p>
                <p v-if="pat.solution != ''">
                  <b>Solução:</b> {{ pat.solution }}
                </p>
                <span class="p-d-flex p-jc-end">
                  <Button
                    label="Ver PAT"
                    class="p-button-sm p-button-primary"
                    icon="pi pi-eye"
                    @click="viewPat(pat.id)"
                  />
                </span>
              </template>
            </Card>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import EquipmentsService from "@/services/equipment.service";
export default {
  name: "EquipmentInfo",
  props: {
    patId: {
      type: Number,
      required: true,
    },
    equipmentInfo: {
      type: Object,
      required: false,
    },
  },
  components: { Loading },
  data() {
    return {
      loading: false,
      patsHistory: [],
    };
  },
  computed: {},
  async mounted() {
    this.loading = true;
    this.patsHistory = await EquipmentsService.getPatsHistory(
      this.equipmentInfo.id
    );
    return (this.loading = false);
  },
  methods: {
    viewPat(patId) {
      let route = this.$router.resolve({
        path: `/pats/${patId}`,
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>
